import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Button from '../../../atoms/button';
import ConfigurationHeader from '../../../components/configuration_header';
import ConfigurationPreview from '../../../components/configuration_preview';
import {
  renameConfiguration, cancelConfiguration,
  addIOModules, addComModules, removeModule,
  setActiveStep, duplicateModule, addCartridge, removeCartridge,
  replaceModule, changeSoftwareVersion, insertModulesBefore, insertModulesAfter,
  addNewIOIsland, removeIOIsland, renameIOIsland,
  addIslandModules, addIslandComModules, addIslandCartridge, removeIslandCartridge, duplicateIslandModule,
  removeIslandModule, insertIslandModulesBefore, insertIslandModulesAfter, replaceIslandModule,
  replaceSelectedAdditionalDevice, replaceIslandSelectedAdditionalDevice,
  changeSoftwareAccessories, setModuleWarranty, setIslandModuleWarranty, addModuleAccessory,
  addIslandModuleAccessory, addIslandModuleAuxiliary, updateModule, updateIslandModule, addModuleAuxiliary,
  addModuleSensor, addIslandModuleSensor, preSaveConfiguration, addModuleSparePart, addIslandModuleSparePart,
  insertModuleAtSlot, insertIslandModuleAtSlot, setRack, setIslandRack, createRemoteAreaWithRIO, setIslandRackForRemote, addLocalRack, removeLocalRack, addLocalRackForIsland, removeIslandLocalRack,
  duplicateIsland,
  duplicateRemote
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, busExpansionType, possible_starter_selections, pacdrive_ranges, configurationModuleType, rack_question, mc80_range_id, surveyTypes, surveyEventTypes, eventForceShowingSurvey, m580_distributed_ranges } from '../../../constants';
import { getStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import { getCompatibleModules } from '../../get-modules/ducks';
import { getSoftwares } from '../../get-accessories/ducks';
import Device from '../../../models/Device';
import Configuration from '../../../models/Configuration';
import { SeTabbar } from '@se/web-ui-react';
import IslandListSection from '../../../components/island_list_section';
import MsxIcons from '../../msx-icons';
import { getAccessories } from '../../get-accessories/ducks';
import { getModuleActions } from '../../get-module-actions/ducks';
import RulesDisplayer from '../../../components/rules_displayer';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import ConfigurationEditorOptionsSection from '../../../components/configuration_editor_options_section';
import { appConfiguration } from '../../../utils/app-starter';
import { logDeleteCBRFilterEvent, logSurveyOpenEvent, logSurveySubmitEvent, logViewIOTypes } from '../../../utils/analytics-logger';
import { showNotificationWithButton } from '../../notification/ducks';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import LoadingSpinner from '../../../atoms/loading';
import PacConfigurationPreview from '../../../components/pac_configuration_preview';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { exportToMyProduct, exportToMyProject } from '../../export/ducks';
import { getCartUrl } from '../../../utils/my-product';
import { resetCBRSelectedItems, setCBRSelectedItems } from '../../call-by-range/ducks';
import AddToMyProductButton from '../../../components/add_to_my_product_button';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import EdgeConfigurationPreview from '../../../components/edge_configuration_preview';
import Notification from '../../notification';
import RemoteAreaListSection from '../../../components/remote_area_list_section';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 2em);
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 40px 0px 16px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
`;

const TabSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 1 auto;
  margin-top: -5px;
`;
const TabContent = styled.div`
`;

const NavigationTab = styled.nav`
  display: flex;
`;
const NavigationTabItem = styled.a`
  margin: 0 !important;
  padding: 0 15px !important;
  @media (max-width: 800px) {
    font-size: 14px !important;
  }
`;

const NavigationTabItemIcon = styled.span`
  display: inline-block;
  margin-left: 4px;
`;

const Section = styled.section`
  display: block;
`;
const MainSection = styled(Section)`
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const NavigationButtonRow = styled.div`
  display: flex;
  justify-content: center;
  ${props => props.mBottom && `margin-bottom: ${props.mBottom}px;`}
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const GraphicalViewWrapper = styled.div`
`;

const possibleGraphicalViewState = {
  preview_configuration: 0,
  io_island: 1,
  remote_area: 3
};

class ConfigurationEditorScreen extends React.Component {

  constructor(props) {
    super(props);
    this.renameIOIslandWithSlot = this.renameIOIslandWithSlot.bind(this);
    this.state = {
      graphicalViewState: possibleGraphicalViewState.preview_configuration,
      selectedIOIslandSlot: null,
      isDesktop: window.innerWidth > 800,
      isIslandName: '',
      ioIslands: [],
    };
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  handleForcedRackAddition = (rackId) => {
    this.props.setRack(this.props.configuration, rackId).then(newConf => {
      this.props.openModal({
        modalType: 'add_module',
        modalProps: {
          addDevices: this.addComModules,
          categories: [],
          remainingCriteria: {},
          sharedOptions: {},
          moduleType: configurationModuleType.com_module,
          questionType: "POWER_SUPPLY_PAC",
          hideQuantity: true,
          baseKey: 'add_pac_power',
          loadModulesAtStart: true,
          disableCrossModal: true,
        },
      });
    });
  }

  componentDidMount = () => {
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });
    window.addEventListener("resize", this.updateIsDesktop);
    if (this.props.configuration.starterType === possible_starter_selections.PAC && this.props.configuration.rangeInfo?.needRack && this.props.configuration.rack == null) {
      this.props.openModal({
        modalType: 'set-rack',
        modalProps: {
          questionType: rack_question,
          disableCrossModal: true,
          setRack: (rackId) => {
            this.handleForcedRackAddition(rackId);
          },
          isIsland: false
        },
      });
    }
    this.props.getSoftwares(this.props.configuration.headModule.id);
    this.refreshModules();
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this.props.closeModal();
  }

  get selectedIOIsland() {
    const slot = this.state.selectedIOIslandSlot;
    const config = new Configuration(this.props.configuration);
    const matchingIOIslands = config.ioIslands.filter(isl => isl.slot === slot);
    return matchingIOIslands.length ? matchingIOIslands[0] : null;
  }

  get hasSelectedIOIsland() {
    return this.selectedIOIsland !== null;
  }

  isNavigationDisabled() {
    return this.props.compatibleModules.isLoading || this.props.compatibleIslandModules.isLoading || this.props.configurationSaver.isSaving;
  }

  selectIoIsland(slot) {
    if (slot !== this.state.selectedIOIslandSlot) {
      this.setState({ selectedIOIslandSlot: slot, graphicalViewState: possibleGraphicalViewState.io_island }, () => this.refreshIslandModules());
    }
  }

  selectMainIsland() {
    this.setState({ selectedIOIslandSlot: null, graphicalViewState: possibleGraphicalViewState.preview_configuration });
  }

  selectRemoteArea(slot) {
    if (slot !== this.state.selectedIOIslandSlot) {
      this.setState({ selectedIOIslandSlot: slot, graphicalViewState: possibleGraphicalViewState.remote_area }, () => this.refreshIslandModules().then(() => {
        const targettedRemoteArea = this.selectedIOIsland;
        if (targettedRemoteArea && targettedRemoteArea.configuration && targettedRemoteArea.configuration.rack == null) {
          this.props.openModal({
            modalType: 'set-rack',
            modalProps: {
              questionType: rack_question,
              disableCrossModal: true,
              setRack: (rackId) => {
                this.props.setIslandRackForRemote(this.props.configuration, slot, rackId).then(() => {
                  this.props.openModal({
                    modalType: 'add_module',
                    modalProps: {
                      addDevices: this.addIslandComModules,
                      categories: this.props.compatibleIslandModules.comModuleCategories,
                      remainingCriteria: this.props.compatibleIslandModules.comModulesRemainingCriteria,
                      sharedOptions: this.props.compatibleIslandModules.comModulesSharedOptions,
                      moduleType: configurationModuleType.com_module,
                      questionType: "POWER_SUPPLY_PAC",
                      hideQuantity: true,
                      baseKey: 'add_pac_power',
                      selectedIOIslandSlot: slot,
                      loadModulesAtStart: true,
                      disableCrossModal: true,
                    },
                  });
                });
              },
              islandConfiguration: targettedRemoteArea.configuration,
              isIsland: true
            },
          });
        }
      }));
    }
  }

  unselectIoIsland() {
    this.setState({ selectedIOIslandSlot: null, graphicalViewState: possibleGraphicalViewState.io_island });
  }

  unselectRemoteArea() {
    this.setState({ selectedIOIslandSlot: null, graphicalViewState: possibleGraphicalViewState.remote_area });
  }

  refreshModules() {
    return Promise.all([
      this.props.getCompatibleModules(this.props.configuration.id, {}),
    ]);
  }

  refreshIslandModules() {
    const hasSelectedIOIsland = !!((this.state.graphicalViewState === possibleGraphicalViewState.io_island || this.state.graphicalViewState === possibleGraphicalViewState.remote_area) && this.hasSelectedIOIsland);

    if (!hasSelectedIOIsland) {
      return Promise.resolve();
    }
    return Promise.all([
      this.props.getCompatibleModules(this.props.configuration.id, {}, this.selectedIOIsland.slot),
    ]);
  }

  handleAutomaticAdditionalModule = (categories, currentModuleList, addFunction) => {
    const categoryModules = (categories || []).map(cat => cat.references).flat();
    if (!categoryModules || categoryModules.length !== 1) return;
    const newModule = new Device(categoryModules[0]);

    const lastModule = [...(currentModuleList || [])].pop();
    if (!lastModule) return;
    const lastDevice = new Device(lastModule);

    if (busExpansionType.isTransmitter(lastDevice.busExpansionType) && busExpansionType.isReceiver(newModule.busExpansionType)) {
      addFunction(newModule.rawData, 1);
    }
  }

  addModules = (mod, quantity) => {
    return this.props.addIOModules(this.props.configuration, mod, quantity).then(() => {
      this.refreshModules()
        .then(() => {
          this.handleAutomaticAdditionalModule(
            this.props.compatibleModules.ioModuleCategories,
            this.props.configuration.ioModules,
            this.addModules
          );
        });
    });
  }

  addComModules = (mod, quantity, rackLocation) => {
    return this.props.addComModules(this.props.configuration, mod, quantity, rackLocation).then(() => {
      this.refreshModules()
        .then(() => {
          this.handleAutomaticAdditionalModule(
            this.props.compatibleModules.comModuleCategories,
            this.props.configuration.comModules,
            this.addComModules
          );
        });
    });
  }

  addCartridge = (mod, slot) => {
    return this.props.addCartridge(this.props.configuration, mod, slot).then(() => {
      this.refreshModules();
    });
  }

  changeSoftwareVersion = (newSoftwareVersion) => {
    return this.props.changeSoftwareVersion(this.props.configuration, newSoftwareVersion).then(() => {
      this.refreshModules();
    });
  }

  removeCartridge = (slot) => {
    return this.props.removeCartridge(this.props.configuration, slot).then(() => {
      this.refreshModules();
    });
  }

  duplicateModule = (slot, moduleType) => {
    return this.props.duplicateModule(this.props.configuration, slot, moduleType).then(() => {
      this.refreshModules();
    });
  }

  removeModule = (slot, moduleType, decreaseSlot = true, rackLocation = null) => {
    return this.props.removeModule(this.props.configuration, slot, moduleType, decreaseSlot, rackLocation).then(() => {
      this.refreshModules();
    });
  }

  insertModuleAtSlot = (slot, moduleType, reference, quantity, rackLocation) => {
    return this.props.insertModuleAtSlot(this.props.configuration, slot, moduleType, reference, quantity, rackLocation).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  insertIslandModuleAtSlot = (targetSlot, moduleType, reference, quantity, rackLocation) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.insertIslandModuleAtSlot(this.props.configuration, selectedSlot, targetSlot, moduleType, reference, quantity, rackLocation).then(() => {
      this.refreshIslandModules();
    });
  }

  insertModulesBefore = (slot, moduleType, reference, quantity) => {
    return this.props.insertModulesBefore(this.props.configuration, slot, moduleType, reference, quantity).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  insertModulesAfter = (slot, moduleType, reference, quantity) => {
    return this.props.insertModulesAfter(this.props.configuration, slot, moduleType, reference, quantity).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  handlePacdriveModal = (module) => {
    this.props.openModal({
      modalType: 'pacdrive-adjust',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: (newReferenceID) => {
          this.replaceModule(0, configurationModuleType.head_module, newReferenceID, false, null).then((data) => {
            this.props.getSoftwares(data?.configuration?.headModule?.id);
            this.refreshModules();
          }).catch(() => { });
          this.props.closeModal();
        },
        headModule: module,
      }
    });
  }

  replaceModule = (slot, moduleType, newReferenceID, showAdjustment = true, rackLocation = null) => {

    return this.props.replaceModule(this.props.configuration, slot, moduleType, newReferenceID, rackLocation).then((data) => {
      const headModuleKits = this.props.pacdriveKits.kits[data?.configuration?.headModule?.id] || {};
      if (showAdjustment && moduleType === configurationModuleType.head_module
        && pacdrive_ranges.includes(data?.configuration?.rangeInfo?.rangeName)
        && Object.keys(headModuleKits).length > 0) {
        this.handlePacdriveModal(data?.configuration?.headModule);
      } else {
        this.refreshModules();
        if (moduleType === configurationModuleType.head_module) {
          this.props.getSoftwares(data?.configuration?.headModule?.id);
        }
      }
    }).catch(() => { });
  }

  updateModule = (slot, moduleType, mod) => {
    return this.props.updateModule(this.props.configuration, slot, moduleType, mod).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  addNewIOIsland = (headModule, protocolName, filters) => {
    return this.props.addNewIOIsland(this.props.configuration, headModule, protocolName, filters).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  createIOIsland = (headModule, protocolName, filters) => {
    return this.addNewIOIsland(headModule, protocolName, filters).then(() => {
      const newIOIslandSlot = Math.max(...this.props.configuration.ioIslands.map(isl => isl.slot));
      if (newIOIslandSlot > 0) {
        this.selectIoIsland(newIOIslandSlot);
      }
    });
  }

  addIOIslandWithRack = (rackId) => {
    return this.props.addNewIOIslandWithRack(this.props.configuration, rackId).then(() => {
      this.refreshModules();
    });
  }

  createIOIslandWithRack = (rackId) => {
    return this.addIOIslandWithRack(rackId).then(() => {
      const newIOIslandSlot = Math.max(...this.props.configuration.ioIslands.map(isl => isl.slot));
      if (newIOIslandSlot > 0) {
        this.setState({ selectedIOIslandSlot: newIOIslandSlot, graphicalViewState: possibleGraphicalViewState.extension_rack }, () => {
          return this.refreshIslandModules().then(() => {
            this.props.openModal({
              modalType: 'add_module',
              modalProps: {
                addDevices: this.addIslandComModules,
                categories: this.props.compatibleIslandModules.comModuleCategories,
                remainingCriteria: this.props.compatibleIslandModules.comModulesRemainingCriteria,
                sharedOptions: this.props.compatibleIslandModules.comModulesSharedOptions,
                moduleType: configurationModuleType.com_module,
                questionType: "POWER_SUPPLY_PAC",
                hideQuantity: true,
                baseKey: 'add_pac_power',
                selectedIOIslandSlot: newIOIslandSlot,
                disableCrossModal: true,
              },
            });
          })
        });
      }
    });
  }

  openNewRemoteArea = () => {
    const newRemoteArea = Math.max(...this.props.configuration.ioIslands.map(isl => isl.slot));
      if (newRemoteArea > 0) {
        this.selectRemoteArea(newRemoteArea);
      }
  }

  createRemoteAreaWithRIO = (rio, protocol, filters) => {

    const currentNbRedboxes = this.props.configuration.redboxes?.length || 0;

    this.props.createRemoteAreaWithRIO(this.props.configuration, rio, protocol, filters).then((conf) => {
      // Open the redboxes management modal if redboxes are being inserted along with the new remote area (first time only)
      if (currentNbRedboxes === 0 && conf?.redboxes?.length > 0) {
        this.props.openModal({
          modalType: 'manage-redboxes',
          modalProps: {
            // Callback function which will select the new remote area after the redboxes have been adjusted
            onClose: () => {
              this.openNewRemoteArea();
            }
          }
        });
      } else {
        this.openNewRemoteArea();
      }
    });
  }

  removeIOIsland = (slot) => {
    return this.props.removeIOIsland(this.props.configuration, slot).then(() => {
      this.refreshModules();
    }).catch(() => { });
  }

  renameIOIsland = (name) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.renameIOIsland(this.props.configuration, selectedSlot, name);
  }

  renameIOIslandWithSlot = (name, islandSlot) => {
    return this.props.renameIOIsland(this.props.configuration, islandSlot, name);
  }

  addIslandModules = (mod, quantity) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandModules(this.props.configuration, selectedSlot, mod, quantity).then(() => {
      this.refreshIslandModules()
        .then(() => {
          if (this.selectedIOIsland) {
            this.handleAutomaticAdditionalModule(
              this.props.compatibleIslandModules.ioModuleCategories,
              this.selectedIOIsland.configuration.ioModules,
              this.addIslandModules
            );
          }
        });
    });
  }

  addIslandComModules = (mod, quantity, rackLocation) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandComModules(this.props.configuration, selectedSlot, mod, quantity, rackLocation).then(() => {
      this.refreshIslandModules()
        .then(() => { });
    });
  }

  addIslandCartridge = (mod, targetSlot) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addCartridge(this.props.configuration, selectedSlot, mod, targetSlot).then(() => {
      this.refreshIslandModules();
    });
  }

  removeIslandCartridge = (targetSlot) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.removeIslandCartridge(this.props.configuration, selectedSlot, targetSlot).then(() => {
      this.refreshIslandModules();
    });
  }

  duplicateIslandModule = (targetSlot, moduleType) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.duplicateIslandModule(this.props.configuration, selectedSlot, targetSlot, moduleType).then(() => {
      this.refreshIslandModules();
    });
  }

  removeIslandModule = (targetSlot, moduleType, decreaseSlot = true, rackLocation = null) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.removeIslandModule(this.props.configuration, selectedSlot, targetSlot, moduleType, decreaseSlot, rackLocation).then(() => {
      this.refreshIslandModules();
    });
  }

  insertIslandModulesBefore = (targetSlot, moduleType, reference, quantity) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.insertIslandModulesBefore(this.props.configuration, selectedSlot, targetSlot, moduleType, reference, quantity).then(() => {
      this.refreshIslandModules();
    });
  }

  insertIslandModulesAfter = (targetSlot, moduleType, reference, quantity) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.insertIslandModulesAfter(this.props.configuration, selectedSlot, targetSlot, moduleType, reference, quantity).then(() => {
      this.refreshIslandModules();
    });
  }

  replaceIslandModule = (targetSlot, moduleType, newReferenceID, showAdjustment = false, rackLocation = null) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.replaceIslandModule(this.props.configuration, selectedSlot, targetSlot, moduleType, newReferenceID, rackLocation).then(() => {
      this.refreshIslandModules();
    });
  }

  updateIslandModule = (targetSlot, moduleType, mod) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.updateIslandModule(this.props.configuration, selectedSlot, targetSlot, moduleType, mod).then(() => {
      this.refreshIslandModules();
    });
  }

  replaceSelectedAdditionalDevice = (targetSlot, moduleType, layer, selectedDevice, rackLocation = null) => {
    return this.props.replaceSelectedAdditionalDevice(this.props.configuration, targetSlot, moduleType, layer, selectedDevice, rackLocation).then(() => {
      this.refreshModules();
    });
  }

  replaceIslandSelectedAdditionalDevice = (targetSlot, moduleType, layer, selectedDevice, rackLocation = null) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.replaceIslandSelectedAdditionalDevice(this.props.configuration, selectedSlot, targetSlot, moduleType, layer, selectedDevice, rackLocation).then(() => {
      this.refreshModules();
    });
  }

  setModuleWarranty = (targetSlot, moduleType, warranty) => {
    return this.props.setModuleWarranty(this.props.configuration, targetSlot, moduleType, warranty);
  }

  setIslandModuleWarranty = (targetSlot, moduleType, warranty) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.setIslandModuleWarranty(this.props.configuration, selectedSlot, targetSlot, moduleType, warranty);
  }

  addModuleAccessory = (targetSlot, moduleType, newAccessory) => {
    return this.props.addModuleAccessory(this.props.configuration, targetSlot, moduleType, newAccessory);
  }

  addModuleAuxiliary = (targetSlot, moduleType, newAccessory) => {
    return this.props.addModuleAuxiliary(this.props.configuration, targetSlot, moduleType, newAccessory);
  }

  addModuleSensor = (targetSlot, moduleType, newAccessory) => {
    return this.props.addModuleSensor(this.props.configuration, targetSlot, moduleType, newAccessory);
  }

  addModuleSparePart = (targetSlot, moduleType, newAccessory) => {
    return this.props.addModuleSparePart(this.props.configuration, targetSlot, moduleType, newAccessory);
  }

  addIslandModuleAccessory = (targetSlot, moduleType, newAccessory) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandModuleAccessory(this.props.configuration, selectedSlot, targetSlot, moduleType, newAccessory);
  }

  addIslandModuleAuxiliary = (targetSlot, moduleType, newAccessory) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandModuleAccessory(this.props.configuration, selectedSlot, targetSlot, moduleType, newAccessory);
  }

  addIslandModuleSensor = (targetSlot, moduleType, newAccessory) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandModuleSensor(this.props.configuration, selectedSlot, targetSlot, moduleType, newAccessory);
  }

  addIslandModuleSparePart = (targetSlot, moduleType, newAccessory) => {
    const selectedSlot = this.selectedIOIsland.slot;
    return this.props.addIslandModuleSparePart(this.props.configuration, selectedSlot, targetSlot, moduleType, newAccessory);
  }

  getModuleActions = (moduleSlot, moduleType, updateSlot = true, rackLocation = null) => {
    let selectedIslandSlot;
    if (this.selectedIOIsland) {
      selectedIslandSlot = this.selectedIOIsland.slot;
    }
    return this.props.getModuleActions(this.props.configuration.id, moduleSlot, moduleType, updateSlot, selectedIslandSlot, rackLocation);
  }

  renderHeaderContent = (config) => {
    const hasSelectedIOIsland = !!((this.state.graphicalViewState === possibleGraphicalViewState.io_island || this.state.graphicalViewState === possibleGraphicalViewState.remote_area) && this.hasSelectedIOIsland);
    return (
      <HeaderContent>
        <ConfigurationHeader
          configuration={config}
          setConfigurationName={(name) => {
            this.props.renameConfiguration(config.id, name)
          }}
          isLoading={this.props.configurationSaver.isSaving}
          renderRangeRules={this.renderRangeRules}
        >
        </ConfigurationHeader>
        {hasSelectedIOIsland &&
          <ConfigurationHeader
            configuration={this.selectedIOIsland.configuration}
            selectedIOIsland={this.selectedIOIsland}
            setConfigurationName={this.renameIOIsland}
            isIsland={true}
            isLoading={this.props.configurationSaver.isSaving}
            renderRangeRules={this.renderRangeRules}
          >
          </ConfigurationHeader>
        }
      </HeaderContent>
    );
  }

  showIoTypes = () => {
    const config = new Configuration(this.props.configuration);
    this.props.openModal({
      modalType: 'io_types',
      modalProps: {
        configuration: config
      }
    });
    logViewIOTypes(config);
  }

  previewConfiguration = () => {
    const config = new Configuration(this.props.configuration);
    let modalType = 'preview-configuration';
    if (this.props.configuration.starterType === possible_starter_selections.PAC) {
      modalType = 'preview-pac-configuration';
    } else if (this.props.configuration.starterType === possible_starter_selections.EDGE) {
      modalType = 'preview-edge-configuration';
    }

    this.props.openModal({
      modalType,
      modalProps: {
        configuration: config,
      }
    });
  }

  renderMainSection = (config) => {
    const selectedGraphicalTab = this.state.graphicalViewState;
    const isPLCContext = config.starterType === possible_starter_selections.PLC_IO;
    const isPACComplexContext = config.starterType === possible_starter_selections.PAC && m580_distributed_ranges.includes(config.rangeInfo?.rangeName);
    const navigationDisabled = this.isNavigationDisabled();

    return (
      <MainSection>
        <TabSection id='TabSection'>
          <SeTabbar className="shadow" option="content" overflow="scroll">
            <NavigationTab id='NavigationTab'>
              <NavigationTabItem
                disabled={navigationDisabled}
                className={selectedGraphicalTab === possibleGraphicalViewState.preview_configuration ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  if (!navigationDisabled) {
                    this.setState({ graphicalViewState: possibleGraphicalViewState.preview_configuration, selectedIOIslandSlot: null });
                  }
                }}
              >
                {(config.starterType === possible_starter_selections.PAC && mc80_range_id !== config.rangeInfo?.rangeId) ? I10n.get('screen.config_editor.preview.main_rack') : I10n.get('screen.head_device_selector_screen.plc')}
                {config.hasMasterValidationError() && <NavigationTabItemIcon title={I10n.get('screen.config_editor.preview.validation_error')}>
                  <MsxIcons name="alert" size="nano" color="error"></MsxIcons>
                </NavigationTabItemIcon>}
              </NavigationTabItem>
              {isPLCContext && config.rangeInfo?.maxTotalIOIslands > 0 &&
                (
                  <NavigationTabItem
                    id="io-island-tab"
                    disabled={navigationDisabled}
                    className={selectedGraphicalTab === possibleGraphicalViewState.io_island ? 'active' : ''}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!navigationDisabled) {
                        this.setState({ graphicalViewState: possibleGraphicalViewState.io_island });
                      }
                    }}
                  >
                    {I10n.get('screen.config_editor.io_island')}
                    {config.hasIslandsValidationError() && <NavigationTabItemIcon title={I10n.get('screen.config_editor.io_island.validation_error')}>
                      <MsxIcons name="alert" size="nano" color="error"></MsxIcons>
                    </NavigationTabItemIcon>}
                  </NavigationTabItem>
                )
              }
              {isPACComplexContext && config.headModule?.maxRemoteArea > 0 && (
                <NavigationTabItem
                  disabled={navigationDisabled}
                  className={selectedGraphicalTab === possibleGraphicalViewState.remote_area ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!navigationDisabled) {
                      this.setState({ graphicalViewState: possibleGraphicalViewState.remote_area });
                    }
                  }}
                >
                  {I10n.get('screen.config_editor.remote_area')}
                  {config.hasIslandsValidationError() && <NavigationTabItemIcon title={I10n.get('screen.config_editor.io_island.validation_error')}>
                    <MsxIcons name="alert" size="nano" color="error"></MsxIcons>
                  </NavigationTabItemIcon>}
                </NavigationTabItem>
              )}
            </NavigationTab>
          </SeTabbar>
          <TabContent>
            {selectedGraphicalTab === possibleGraphicalViewState.preview_configuration && this.renderMainGraphicalView(config)}
            {isPLCContext && selectedGraphicalTab === possibleGraphicalViewState.io_island && this.renderIslandGraphicalView(config)}
            {isPACComplexContext && selectedGraphicalTab === possibleGraphicalViewState.remote_area && this.renderRemoteAreaGraphicalView(config)}
          </TabContent>
        </TabSection>
      </MainSection>
    );
  }

  renderMainGraphicalViewComponent = (props) => {
    if (this.props.configuration.starterType === possible_starter_selections.PAC) {
      return (<PacConfigurationPreview {...props}></PacConfigurationPreview>);
    } else if (this.props.configuration.starterType === possible_starter_selections.EDGE) {
      return (
        <EdgeConfigurationPreview
          {...props}
          show3DViewer={() => {
            const config = new Configuration(this.props.configuration);
            this.props.openModal({
              modalType: 'edge-3d-viewer',
              modalProps: {
                configuration: config,
                showExports: false
              }
            });
          }}
        ></EdgeConfigurationPreview>);
    }
    return (<ConfigurationPreview{...props}></ConfigurationPreview>);
  }

  renderMainGraphicalView = (config) => {
    const props = {
      configuration: config,
      openModal: this.props.openModal,
      closeModal: this.props.closeModal,
      setModuleWarranty: this.setModuleWarranty,
      addModuleAccessory: this.addModuleAccessory,
      addModuleAuxiliary: this.addModuleAuxiliary,
      addModuleSensor: this.addModuleSensor,
      addModuleSparePart: this.addModuleSparePart,
      addDevices: this.addModules,
      addComModules: this.addComModules,
      addCartridge: this.addCartridge,
      getAccessories: this.props.getAccessories,
      getModuleActions: this.getModuleActions,
      changeSoftwareVersion: this.changeSoftwareVersion,
      removeCartridge: this.removeCartridge,
      duplicateModule: this.duplicateModule,
      removeModule: this.removeModule,
      replaceSelectedAdditionalDevice: this.replaceSelectedAdditionalDevice,
      replaceModule: this.replaceModule,
      updateModule: this.updateModule,
      insertModuleAtSlot: this.insertModuleAtSlot,
      insertModulesBefore: this.insertModulesBefore,
      insertModulesAfter: this.insertModulesAfter,
      comModulesCategories: this.props.compatibleModules.comModuleCategories,
      ioModulesCategories: this.props.compatibleModules.ioModuleCategories,
      ioModulesRemainingCriteria: this.props.compatibleModules.ioModulesRemainingCriteria,
      comModulesRemainingCriteria: this.props.compatibleModules.comModulesRemainingCriteria,
      ioModulesSharedOptions: this.props.compatibleModules.ioModulesSharedOptions,
      comModulesSharedOptions: this.props.compatibleModules.comModulesSharedOptions,
      cartridgesCategories: this.props.compatibleModules.cartridgeCategories,
      comModulesFailedRules: this.props.compatibleModules.comModulesFailedRules,
      ioModulesFailedRules: this.props.compatibleModules.ioModulesFailedRules,
      cartridgesFailedRules: this.props.compatibleModules.cartridgesFailedRules,
      ioModulesDevicesFailedRules: this.props.compatibleModules.ioModulesDevicesFailedRules,
      comModulesDevicesFailedRules: this.props.compatibleModules.comModulesDevicesFailedRules,
      cartridgesDevicesFailedRules: this.props.compatibleModules.cartridgesDevicesFailedRules,
      canAddExtensionRack: this.props.compatibleModules.canAddExtensionRack,
      isLoading: (this.props.compatibleModules.isLoading
        || this.props.configurationSaver.isSaving),
      moduleActionsLoading: this.props.moduleActions.isLoading,
      accessoriesLoading: this.props.accessories.accessories.isLoading,
      canReplaceHead: true,
      onAdjustRequested: this.handlePacdriveModal,
      pacdriveKits: this.props.pacdriveKits.kits,
      allowSavedModifications: this.props.configuration.allowSavedModifications,
      showIoTypes: this.showIoTypes,
      previewConfiguration: this.previewConfiguration,
      addLocalRack: (rackId) => this.props.addLocalRack(this.props.configuration, rackId),
      removeLocalRack: (rackLocation) => { this.props.removeLocalRack(this.props.configuration, rackLocation); },
      hasPowerSupplies: config.hasPowerSupplies(),
      redboxes: config.redboxes
    };
    return (
      <GraphicalViewWrapper>
        {this.renderMainGraphicalViewComponent(props)}
      </GraphicalViewWrapper>
    );
  }

  renderIslandGraphicalView = (config) => {

    const props = {
      configuration: this.selectedIOIsland?.configuration,
      openModal: (({ modalProps, ...payload }) => {
        const _modalProps = modalProps || {};
        _modalProps.selectedIOIslandSlot = this.selectedIOIsland?.slot;
        return this.props.openModal({ modalProps: _modalProps, ...payload });
      }),
      closeModal: this.props.closeModal,
      setModuleWarranty: this.setIslandModuleWarranty,
      addModuleAccessory: this.addIslandModuleAccessory,
      addModuleAuxiliary: this.addIslandModuleAuxiliary,
      addModuleSensor: this.addIslandModuleSensor,
      addModuleSparePart: this.addIslandModuleSparePart,
      addDevices: this.addIslandModules,
      addCartridge: this.addIslandCartridge,
      getAccessories: this.props.getAccessories,
      getModuleActions: this.getModuleActions,
      removeCartridge: this.removeIslandCartridge,
      duplicateModule: this.duplicateIslandModule,
      removeModule: this.removeIslandModule,
      replaceModule: this.replaceIslandModule,
      updateModule: this.updateIslandModule,
      replaceSelectedAdditionalDevice: this.replaceIslandSelectedAdditionalDevice,
      insertModuleAtSlot: this.insertIslandModuleAtSlot,
      insertModulesBefore: this.insertIslandModulesBefore,
      insertModulesAfter: this.insertIslandModulesAfter,
      ioModulesCategories: this.props.compatibleIslandModules.ioModuleCategories,
      cartridgesCategories: this.props.compatibleIslandModules.cartridgeCategories,
      ioModulesRemainingCriteria: this.props.compatibleIslandModules.ioModulesRemainingCriteria,
      comModulesRemainingCriteria: this.props.compatibleIslandModules.comModulesRemainingCriteria,
      ioModulesSharedOptions: this.props.compatibleIslandModules.ioModulesSharedOptions,
      comModulesSharedOptions: this.props.compatibleIslandModules.comModulesSharedOptions,
      ioModulesFailedRules: this.props.compatibleIslandModules.ioModulesFailedRules,
      cartridgesFailedRules: this.props.compatibleIslandModules.cartridgesFailedRules,
      ioModulesDevicesFailedRules: this.props.compatibleIslandModules.ioModulesDevicesFailedRules,
      cartridgesDevicesFailedRules: this.props.compatibleIslandModules.cartridgesDevicesFailedRules,
      isLoading: this.props.compatibleIslandModules.isLoading
        || this.props.configurationSaver.isSaving,
      moduleActionsLoading: this.props.moduleActions.isLoading,
      accessoriesLoading: this.props.accessories.accessories.isLoading,
      canReplaceHead: false,
      onAdjustRequested: this.handlePacdriveModal,
      pacdriveKits: this.props.pacdriveKits.kits,
      allowSavedModifications: this.props.configuration.allowSavedModifications,
      showIoTypes: this.showIoTypes,
      previewConfiguration: this.previewConfiguration,
      isIsland: true,
      unselectIsland: event => this.unselectIoIsland()
    }

    return (
      <GraphicalViewWrapper id='graphicalViewerWrapper-renderIslandGraphicalView'>
        {this.hasSelectedIOIsland ?
          <>
            <GraphicalViewWrapper>
              <ConfigurationPreview{...props}></ConfigurationPreview>
            </GraphicalViewWrapper>
          </> :
          <IslandListSection
            configuration={config}
            openModal={this.props.openModal}
            closeModal={this.props.closeModal}
            new={this.addNewIOIsland}
            create={this.createIOIsland}
            edit={(slot) => this.selectIoIsland(slot)}
            delete={(slot) => {
              return new Promise(((resolve) => {
                const requestedIOIslands = config.ioIslands.filter(isl => isl.slot === slot);
                const requestedIOIsland = requestedIOIslands.length ? requestedIOIslands[0] : null;
                if (!requestedIOIsland) {
                  resolve();
                };

                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.removeIOIsland(slot).finally(() => {
                        resolve();
                      });
                      this.props.closeModal();
                    },
                    title: I10n.get('screen.config_editor.io_island.delete.modal.title'),
                    text: I10n.getAndReplace('screen.config_editor.io_island.delete.modal.body', requestedIOIsland.configuration.name),
                    cancelText: I10n.get('app.action.return'),
                    submitText: I10n.get('app.action.confirm'),
                  }
                });
              }));
            }}
            canAdd={!this.props.configurationSaver.isSaving}
            canDelete={!this.props.configurationSaver.isSaving}
            allowSavedModifications={this.props.configuration.allowSavedModifications}
            hasPowerSupplies={config.hasPowerSupplies()}
            renameIOIslandWithSlot={(configurationName, slot) => {
              this.props.renameIOIsland(this.props.configuration, slot, configurationName);
            }}
            duplicateIsland={this.props.duplicateIsland}
            isSaving={this.props.configurationSaver.isSaving}
          >
          </IslandListSection>
        }
      </GraphicalViewWrapper>
    );
  }

  renderRemoteAreaGraphicalView = (config) => {
    const props = {
      configuration: this.selectedIOIsland?.configuration,
      openModal: (({ modalProps, ...payload }) => {
        const _modalProps = modalProps || {};
        _modalProps.selectedIOIslandSlot = this.selectedIOIsland?.slot;
        return this.props.openModal({ modalProps: _modalProps, ...payload });
      }),
      closeModal: this.props.closeModal,
      setModuleWarranty: this.setIslandModuleWarranty,
      addModuleAccessory: this.addIslandModuleAccessory,
      addModuleAuxiliary: this.addIslandModuleAuxiliary,
      addModuleSensor: this.addIslandModuleSensor,
      addModuleSparePart: this.addIslandModuleSparePart,
      addDevices: this.addIslandModules,
      addComModules: this.addIslandComModules,
      addCartridge: this.addIslandCartridge,
      getAccessories: this.props.getAccessories,
      getModuleActions: this.getModuleActions,
      removeCartridge: this.removeIslandCartridge,
      duplicateModule: this.duplicateIslandModule,
      removeModule: this.removeIslandModule,
      replaceModule: this.replaceIslandModule,
      updateModule: this.updateIslandModule,
      replaceSelectedAdditionalDevice: this.replaceIslandSelectedAdditionalDevice,
      insertModuleAtSlot: this.insertIslandModuleAtSlot,
      insertModulesBefore: this.insertIslandModulesBefore,
      insertModulesAfter: this.insertIslandModulesAfter,
      ioModulesCategories: this.props.compatibleIslandModules.ioModuleCategories,
      comModulesCategories: this.props.compatibleIslandModules.comModuleCategories,
      cartridgesCategories: this.props.compatibleIslandModules.cartridgeCategories,
      ioModulesRemainingCriteria: this.props.compatibleIslandModules.ioModulesRemainingCriteria,
      comModulesRemainingCriteria: this.props.compatibleIslandModules.comModulesRemainingCriteria,
      ioModulesSharedOptions: this.props.compatibleIslandModules.ioModulesSharedOptions,
      comModulesSharedOptions: this.props.compatibleIslandModules.comModulesSharedOptions,
      ioModulesFailedRules: this.props.compatibleIslandModules.ioModulesFailedRules,
      cartridgesFailedRules: this.props.compatibleIslandModules.cartridgesFailedRules,
      ioModulesDevicesFailedRules: this.props.compatibleIslandModules.ioModulesDevicesFailedRules,
      cartridgesDevicesFailedRules: this.props.compatibleIslandModules.cartridgesDevicesFailedRules,
      canAddExtensionRack: this.props.compatibleIslandModules.canAddExtensionRack,
      isLoading: this.props.compatibleIslandModules.isLoading
        || this.props.configurationSaver.isSaving,
      moduleActionsLoading: this.props.moduleActions.isLoading,
      accessoriesLoading: this.props.accessories.accessories.isLoading,
      canReplaceHead: false,
      onAdjustRequested: this.handlePacdriveModal,
      pacdriveKits: this.props.pacdriveKits.kits,
      allowSavedModifications: this.props.configuration.allowSavedModifications,
      showIoTypes: this.showIoTypes,
      previewConfiguration: this.previewConfiguration,
      addLocalRack: (rackId) => this.props.addLocalRackForIsland(this.props.configuration, this.selectedIOIsland.slot, rackId),
      removeLocalRack: (rackLocation) => { this.props.removeIslandLocalRack(this.props.configuration, this.selectedIOIsland.slot, rackLocation); },
      isIsland: true,
      unselectIsland: event => this.unselectRemoteArea(),
      redboxes: this.props.configuration.redboxes
    }

    return (
      <GraphicalViewWrapper id='renderRemoteAreaGraphicalView-graphicalViewWrapper'>
        {this.hasSelectedIOIsland ?
          <>
            <GraphicalViewWrapper>
              <PacConfigurationPreview {...props}></PacConfigurationPreview>
            </GraphicalViewWrapper>
          </> :
          <RemoteAreaListSection
            configuration={config}
            openModal={this.props.openModal}
            closeModal={this.props.closeModal}
            create={this.createRemoteAreaWithRIO}
            edit={(slot) => this.selectRemoteArea(slot)}
            delete={(slot) => {
              return new Promise((resolve) => {
                const requestedIOIslands = config.ioIslands.filter(isl => isl.slot === slot);
                const requestedIOIsland = requestedIOIslands.length ? requestedIOIslands[0] : null;
                if (!requestedIOIsland) {
                  resolve();
                }

                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.removeIOIsland(slot).finally(() => {
                        resolve();
                      });
                      this.props.closeModal();
                    },
                    title: I10n.get('screen.config_editor.io_island.delete_rack.modal.title'),
                    text: I10n.getAndReplace('screen.config_editor.io_island.delete.modal.body', requestedIOIsland.configuration.name),
                    cancelText: I10n.get('app.action.return'),
                    submitText: I10n.get('app.action.confirm'),
                  }
                });
              });
            }}
            canAdd={!this.props.configurationSaver.isSaving}
            canDelete={!this.props.configurationSaver.isSaving}
            allowSavedModifications={this.props.configuration.allowSavedModifications}
            renameIOIslandWithSlot={(configurationName, slot) => {
              this.props.renameIOIsland(this.props.configuration, slot, configurationName);
            }}
            duplicateRemote={this.props.duplicateRemote}
            isSaving={this.props.configurationSaver.isSaving}
          >
          </RemoteAreaListSection>
        }
      </GraphicalViewWrapper>
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => { this.confirmationBeforeCancel(isSaved, this.props.backToStart); }, active: true, done: true, hidden: appConfiguration.disableCallByRangeBackToStart },
      { action: () => {
        if (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length === 1) {
          this.props.openModal({
            modalType: 'confirmation',
            modalProps: {
              onCancel: () => { this.props.closeModal(); },
              onSubmit: () => {
                this.props.resetCallByRangeSelectedItems();
                this.props.closeModal();
                if (configurationStatuses.finished === this.props.configuration.status) {
                  this.props.cancel();
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
                }
              },
              title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
              text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
              cancelText: I10n.get('app.action.no'),
              submitText: I10n.get('app.action.yes'),
            }
          });
        }
        else {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.cancel();
          } else {
            this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
          }
        }
      }, active: true, done: true },
      { action: () => { }, active: true, done: isSaved },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.continue();
          } else {
            this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply).then(() => {
            }).catch(() => { });
          }
        }, active: config.canUsePowerSupply(),
        hidden: config.starterType === possible_starter_selections.PAC, done: config.hasPowerSupplies(),
        skipped: isSaved && config.canUsePowerSupply() && !config.hasPowerSupplies() // Don't display the skipped status on in progress configurations
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.accessorize);
          } else {
            if (config.canUsePowerSupply() && !config.hasPowerSupplies()) {
              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => {
                    this.props.preSaveConfiguration(this.props.configuration, stepsConfig.accessorize).then(() => {
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  onSubmit: () => {
                    this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply).then(() => {
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  title: I10n.get('modal.skip_power_supply_selection.title'),
                  text: I10n.get('modal.skip_power_supply_selection.body'),
                  cancelText: I10n.get('app.action.no'),
                  submitText: I10n.get('app.action.yes'),
                }
              });
            } else {
              this.props.preSaveConfiguration(this.props.configuration, stepsConfig.accessorize).then(() => {
              }).catch(() => { });
            }
          }
        }, active: config.fullConfigurationHasDevicesToAccessorize(), done: isSaved,
        skipped: isSaved && !config.hasDeviceAccessorized() && !config.hasSoftwareLicenseSelection()
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.save_screen);
          } else {
            if (config.canUsePowerSupply() && !config.hasPowerSupplies()) {
              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => {
                    this.props.saveConfiguration(this.props.configuration).then(() => {
                      this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  onSubmit: () => {
                    this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply).then(() => {
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  title: I10n.get('modal.skip_power_supply_selection.title'),
                  text: I10n.get('modal.skip_power_supply_selection.body'),
                  cancelText: I10n.get('app.action.no'),
                  submitText: I10n.get('app.action.yes'),
                }
              });
            } else {
              this.props.saveConfiguration(this.props.configuration).then(() => {
                this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
              }).catch(() => { });
            }
          }
        }, active: true, done: isSaved
      },
    ];
  }

  performAddToCart = (config) => {
    if (configurationStatuses.finished !== this.props.configuration.status) {
      this.props.saveConfigurationWithoutStepChange(this.props.configuration).then(() => {}).catch(() => { });
    }

    if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
      this.props.exportToMyProject(config);
    } else {
      const x = this.props.exportToMyProduct(config);
      x.then(() => {
        if (window.top === window.self) {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification'),
            'success',
            () => (
              <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                {I10n.get('add_to_my_product.notification.button')}
              </Button>
            )
          );
        }
      }).catch(() => {
        this.props.showNotification(
          I10n.get('add_to_my_product.notification.error'),
          'error'
        );
      });
    }
  }

  handleAddToMyProductAction = (config) => {
    if (config.containsPrecommercializedProducts()) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            this.performAddToCart(config);
            this.props.closeModal();
          },
          title: I10n.get('important_information'),
          text: I10n.get((appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable || appConfiguration.launchFromWorkspace) ? 'precommercialized_products_warning.body.project_builder' : 'precommercialized_products_warning.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      this.performAddToCart(config);
    }
  }

  renderAddToMyProductButton = () => {
    const config = new Configuration(this.props.configuration);

    return (
      <AddToMyProductButton
        distributorAddToMyProductLabel={appConfiguration.addToMyProductLabel}
        seamlessSession={appConfiguration.seamlessSession}
        launchFromWorkspace={appConfiguration.launchFromWorkspace}
        isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
        unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        disabled={this.props.export.my_product.isLoading || this.props.configurationSaver.isSaving}
        callback={() => {
          if (config.canUsePowerSupply() && !config.hasPowerSupplies() && configurationStatuses.finished !== this.props.configuration.status) {
            this.props.openModal({
              modalType: 'confirmation',
              modalProps: {
                onCancel: () => {
                  // This is important to close the modal BEFORE the action
                  this.props.closeModal();
                  // This function might reopen it
                  this.handleAddToMyProductAction(config);
                },
                onSubmit: () => {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply).then(() => {
                  }).catch(() => { });
                  this.props.closeModal();
                },
                title: I10n.get('modal.skip_power_supply_selection.title'),
                text: I10n.get('modal.skip_power_supply_selection.body'),
                cancelText: I10n.get('app.action.no'),
                submitText: I10n.get('app.action.yes'),
              }
            });
          } else {
            this.handleAddToMyProductAction(config);
          }
        }}
        fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
        expandOnStart={this.props.showButtonAnimations?.addToMyProduct}
      >
      </AddToMyProductButton>
    );
  }

  renderNavigationButtonSection = (config) => {
    const isSaved = config.status === configurationStatuses.finished;
    const canContinue = (!config.hasValidationError() || isSaved) && !this.props.configurationSaver.isSaving;
    const buttons = <>
      <CancelWrapper>
        <Button
          id='configuration-editor-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={event => {
            if (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length === 1) {

              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => { this.props.closeModal(); },
                  onSubmit: () => {
                    this.props.resetCallByRangeSelectedItems();
                    this.props.closeModal();
                    if (configurationStatuses.finished === this.props.configuration.status) {
                      this.props.cancel();
                    } else {
                      this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
                    }
                  },
                  title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
                  text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
                  cancelText: I10n.get('app.action.no'),
                  submitText: I10n.get('app.action.yes'),
                }
              });
            }
            else {
              if (configurationStatuses.finished === this.props.configuration.status) {
                this.props.cancel();
              } else {
                this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
              }
            }
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {this.props.configurationSaver.isSaving ? <LoadingSpinner width="25px" height="25px"></LoadingSpinner> : <Button
        id='configuration-editor-screen-continue-button'
        importance="emphasized"
        primary
        disabled={!canContinue}
        onClick={event => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            if (config.canUsePowerSupply()) {
              this.props.continue();
            } else {
              if (config.fullConfigurationHasDevicesToAccessorize()) {
                this.props.setActiveStep(stepsConfig.accessorize);
              } else {
                this.props.setActiveStep(stepsConfig.save_screen);
              }
            }
          } else {
            if (config.canUsePowerSupply()) {
              this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply);
            } else {
              if (config.fullConfigurationHasDevicesToAccessorize()) {
                this.props.preSaveConfiguration(this.props.configuration, stepsConfig.accessorize);
              } else {
                this.props.saveConfiguration(this.props.configuration).then(() => {
                  this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
                }).catch(() => { });
              }
            }
          }
        }}
      >
        {I10n.get('app.action.continue')}
      </Button>}

    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          <NavigationButtonRow>
            {buttons}
          </NavigationButtonRow>
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  renderRangeRules = (rangeInfo) => {
    return (
      <RulesDisplayer
        openModal={this.props.openModal}
        closeModal={this.props.closeModal}
        rangeName={rangeInfo.rangeName}
        starterType={this.props.configuration.starterType}
      >
      </RulesDisplayer>
    );
  }

  clearCBRCategory = (category) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: () => {
          const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
          if (newValue.selectedItems[category]) {
            newValue.selectedItems[category] = {};
          }
          this.props.setCallByRangeSelectedItems(newValue);
          logDeleteCBRFilterEvent(this.props.configuration?.id, stepsConfig.configuration_editor_screen, category);
          this.props.closeModal();
        },
        title: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.title'),
        text: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.apply'),
      }
    });
  }

  renderScreenContent = (config, isSaved) => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          {this.renderHeaderContent(config)}
          {this.renderMainSection(config)}
          <ConfigurationEditorOptionsSection
            configuration={config}
            preferredProductReference={appConfiguration.preferredProductReference}
            isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
            unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
            favoritesDisabled={this.props.export.my_product.isLoading || this.props.configurationSaver.isSaving}
            onAddToFavorites={() => {
              const x = this.props.exportToMyProduct(config);
              x.then(() => {
              if (window.top === window.self) {
                this.props.showNotification(
                  I10n.get('add_to_my_product.notification'),
                  'success',
                  () => (
                    <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                      {I10n.get('add_to_my_product.notification.button')}
                    </Button>
                  )
                );
              }
            }).catch(() => {
              this.props.showNotification(
                I10n.get('add_to_my_product.notification.error'),
                'error'
              );
            });


            }}
            softwareList={this.props.accessories.software.references}
            isLoadingConfiguration={this.props.configurationSaver.isSaving}
            isLoadingCompatibleModules={this.props.compatibleModules.isLoading ||
              this.props.compatibleIslandModules.isLoading}
            isLoadingSoftwares={this.props.accessories.software.isLoading}
            onSoftwareUpdate={(newSoftwareList) => {
              if (isSaved) {
                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.props.closeModal();
                      this.props.changeSoftwareAccessories(
                        this.props.configuration,
                        newSoftwareList
                      );
                    },
                    title: I10n.get('modal.change_saved_configuration.title'),
                    text: I10n.get('modal.change_saved_configuration.body'),
                    cancelText: I10n.get('app.action.cancel'),
                    submitText: I10n.get('app.action.continue'),
                  }
                });
              } else {
                this.props.changeSoftwareAccessories(
                  this.props.configuration,
                  newSoftwareList
                );
              }
            }}
            switchIsland={(slot) => {
              const config = this.props.configuration;
              const isPACComplexContext = config.starterType === possible_starter_selections.PAC && m580_distributed_ranges.includes(config.rangeInfo?.rangeName);
              if (this.isNavigationDisabled()) {
                return;
              }

              if (slot == null || slot === 0) {
                this.selectMainIsland();
              } else {
                if (isPACComplexContext) {
                  this.selectRemoteArea(slot);
                } else {
                  this.selectIoIsland(slot);
                }
              }
            }}
          >

          </ConfigurationEditorOptionsSection>
          <Notification>
          </Notification>
          {this.renderAddToMyProductButton()}
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading && <Survey
            appTitle={I10n.get('app.title.' + this.props.configuration.starterType)}
            surveyData={this.props.survey?.surveyData}
            getLabel={(key) => I10n.get(key)}
            preselectionnedAnswers={{ 'embedded_survey.choose_a_category': 'embedded_survey.step.graphical_editor' }}
            onOpen={() => {
              logSurveyOpenEvent(surveyEventTypes.intermediate_open, config.id, stepsConfig.configuration_editor_screen);
             }}
            onSubmit={(surveyAnswers) => {
              logSurveySubmitEvent(surveyEventTypes.intermediate_sent, config.id, stepsConfig.configuration_editor_screen, surveyAnswers);
             }}
            fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
            color={appConfiguration.globalStyles.secondaryColor}
          ></Survey>}
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.title.' + this.props.configuration.starterType)}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          renderNavigationButtonSection={<></>}
          steps={getStepperLabels(config.starterType)}
          activeStep={stepsConfig.configuration_editor_screen}
          stepperActions={this.getStepperActions(isSaved)}
          selectedCriteria={this.props.callByRangeReducer?.selectedItems || {}}
          clearCategory={this.clearCBRCategory}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={false}
          showPrecommWarning={this.props.configuration.showPrecommercializedProducts || config.containsPrecommercializedProducts()}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config, isSaved))}
        {this.renderNavigationButtonSection(config)}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    addIOModules: (configuration, mod, quantity) => dispatch(addIOModules(configuration, mod, quantity)),
    addComModules: (configuration, mod, quantity, rackLocation) => dispatch(addComModules(configuration, mod, quantity, rackLocation)),
    addCartridge: (configuration, mod, slot) => dispatch(addCartridge(configuration, mod, slot)),
    getAccessories: (moduleId) => dispatch(getAccessories(moduleId)),
    getModuleActions: (...args) => dispatch(getModuleActions(...args)),
    changeSoftwareVersion: (configuration, newSoftwareVersion) => dispatch(changeSoftwareVersion(configuration, newSoftwareVersion)),
    changeSoftwareAccessories: (configuration, softwareList) => dispatch(changeSoftwareAccessories(configuration, softwareList)),
    removeCartridge: (configuration, slot) => dispatch(removeCartridge(configuration, slot)),
    getCompatibleModules: (configurationID, criteria, specificIslandSlot) => dispatch(getCompatibleModules(configurationID, criteria, true, specificIslandSlot)),
    getSoftwares: (headModuleID) => dispatch(getSoftwares(headModuleID)),
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    duplicateModule: (...args) => dispatch(duplicateModule(...args)),
    removeModule: (...args) => dispatch(removeModule(...args)),
    replaceModule: (...args) => dispatch(replaceModule(...args)),
    updateModule: (...args) => dispatch(updateModule(...args)),
    insertModuleAtSlot: (...args) => dispatch(insertModuleAtSlot(...args)),
    insertIslandModuleAtSlot: (...args) => dispatch(insertIslandModuleAtSlot(...args)),
    insertModulesBefore: (...args) => dispatch(insertModulesBefore(...args)),
    insertModulesAfter: (...args) => dispatch(insertModulesAfter(...args)),
    renameConfiguration: (configId, name) => dispatch(renameConfiguration(configId, name)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    continue: () => dispatch(setActiveStep(stepsConfig.power_supply)),
    cancel: () => dispatch(setActiveStep(stepsConfig.head_device_selector_screen)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    addNewIOIsland: (...args) => dispatch(addNewIOIsland(...args)),
    addNewIOIslandWithRack: (...args) => dispatch(setIslandRack(...args)),
    addLocalRack: (configuration, rackId) => dispatch(addLocalRack(configuration, rackId)),
    addLocalRackForIsland: (configuration, islandSlot, rackId) => dispatch(addLocalRackForIsland(configuration, islandSlot, rackId)),
    removeLocalRack: (configuration, rackLocation) => dispatch(removeLocalRack(configuration, rackLocation)),
    removeIslandLocalRack: (configuration, islandSlot, rackLocation) => dispatch(removeIslandLocalRack(configuration, islandSlot, rackLocation)),
    createRemoteAreaWithRIO: (configuration, rio, protocol, filters) => dispatch(createRemoteAreaWithRIO(configuration, rio, protocol, filters)),
    setIslandRackForRemote: (configuration, islandSlot, rackId) => dispatch(setIslandRackForRemote(configuration, islandSlot, rackId)),
    removeIOIsland: (...args) => dispatch(removeIOIsland(...args)),
    renameIOIsland: (...args) => dispatch(renameIOIsland(...args)),
    addIslandModules: (...args) => dispatch(addIslandModules(...args)),
    addIslandComModules: (...args) => dispatch(addIslandComModules(...args)),
    addIslandCartridge: (...args) => dispatch(addIslandCartridge(...args)),
    removeIslandCartridge: (...args) => dispatch(removeIslandCartridge(...args)),
    duplicateIslandModule: (...args) => dispatch(duplicateIslandModule(...args)),
    removeIslandModule: (...args) => dispatch(removeIslandModule(...args)),
    insertIslandModulesBefore: (...args) => dispatch(insertIslandModulesBefore(...args)),
    insertIslandModulesAfter: (...args) => dispatch(insertIslandModulesAfter(...args)),
    replaceIslandModule: (...args) => dispatch(replaceIslandModule(...args)),
    updateIslandModule: (...args) => dispatch(updateIslandModule(...args)),
    replaceSelectedAdditionalDevice: (...args) => dispatch(replaceSelectedAdditionalDevice(...args)),
    replaceIslandSelectedAdditionalDevice: (...args) => dispatch(replaceIslandSelectedAdditionalDevice(...args)),
    setModuleWarranty: (...args) => dispatch(setModuleWarranty(...args)),
    setIslandModuleWarranty: (...args) => dispatch(setIslandModuleWarranty(...args)),
    addModuleAccessory: (...args) => dispatch(addModuleAccessory(...args)),
    addModuleAuxiliary: (...args) => dispatch(addModuleAuxiliary(...args)),
    addModuleSensor: (...args) => dispatch(addModuleSensor(...args)),
    addModuleSparePart: (...args) => dispatch(addModuleSparePart(...args)),
    addIslandModuleAccessory: (...args) => dispatch(addIslandModuleAccessory(...args)),
    addIslandModuleAuxiliary: (...args) => dispatch(addIslandModuleAuxiliary(...args)),
    addIslandModuleSensor: (...args) => dispatch(addIslandModuleSensor(...args)),
    addIslandModuleSparePart: (...args) => dispatch(addIslandModuleSparePart(...args)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    setRack: (configuration, rackId) => dispatch(setRack(configuration, rackId)),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    saveConfigurationWithoutStepChange: (configuration) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finished, configuration.step)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    getSurvey: () => dispatch(getSurvey(surveyTypes.intermediate)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({addToMyProduct: false, survey: false})),
    duplicateIsland: (slot) => dispatch(duplicateIsland(slot)),
    duplicateRemote: (slot) => dispatch(duplicateRemote(slot))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationEditorScreen);
